import {
  createStore, applyMiddleware, combineReducers,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import mainReducer from './reducers/main';
import userReducer from './reducers/user';

export function initializeStore(initialState) {
  return createStore(
    combineReducers({
      main: mainReducer,
      user: userReducer,
    }),
    initialState,
    composeWithDevTools(applyMiddleware(thunk)),
  );
}
